module.exports = __webpack_public_path__ + "static/colourmomentspink-38473f6a7d84cf8918ba4ebca8a034f9.jpeg";